import React from 'react';
import Tooltip from '@cpg-its/ads.common.tooltip';
import { DividerSection } from '../../../../../global/components/layout/divider-section';
import { PensionEnrollmentProps } from '../../../models/arc-epi-props';
import { PensionEnrollmentPlan } from '../models/pension-enrollment-model';
import { tcsmColors } from '../../../../../global/constants/theme/theme-constants/colors';
import { labelSupplementStyles } from '../../../../../global/constants/theme/styles/components/label-supplement-styles';

interface Props {
    pensionEnrollmentProps: PensionEnrollmentProps;
    selectedPlan: PensionEnrollmentPlan;
}

export function PensionEnrollmentEmployerContributions(props: Props) {
    const { pensionEnrollmentProps, selectedPlan } = props;
    const labelClasses = labelSupplementStyles();

    if (selectedPlan?.employer_base == null && selectedPlan?.employer_match == null) return null;

    return (
        <DividerSection removeDivider>
            <div className={labelClasses.labelLayout}>
                <h3>{pensionEnrollmentProps?.employerMonthlyContributionsHeader}</h3>
                <div className='supplement-wrapper'>
                    <Tooltip iconColor={tcsmColors.blue} title={pensionEnrollmentProps?.employerMonthlyContributionsTooltip} />
                </div>
            </div>
            <h6>{pensionEnrollmentProps?.erBaseContributionLabel} %</h6>
            <b>{selectedPlan?.employer_base || 0}%</b>

            <h6>{pensionEnrollmentProps?.erMatchContributionLabel} %</h6>
            <b>{selectedPlan?.employer_match || 0}%</b>
        </DividerSection>
    );
}